// src/components/safety/view/ScarResultEditor.jsx
import React, { useState } from "react";

export default function ScarResultEditor({ onSubmit }) {
  const [form, setForm] = useState({
    hasAttachment: false,
    comment: "",
    writer: "",
    approver: "",
  });

  const handleChange = (key, value) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  const handleSubmit = () => {
    if (onSubmit) onSubmit(form);
    setForm({ hasAttachment: false, comment: "", writer: "", approver: "" });
  };

  const section = "rounded-lg border bg-white p-3 min-w-0";
  const sectionStyle = { width: '100%', maxWidth: '100%', boxSizing: 'border-box' };

  return (
    <section className={section} style={sectionStyle}>
      <div className="text-xs font-semibold mb-2" style={{ fontSize: '0.75rem', lineHeight: '1rem' }}>결과 회신 등록</div>
      <div className="space-y-3 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
        <div className="flex items-center gap-2 text-xs min-w-0" style={{ fontSize: '0.75rem', width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
          <label className="flex items-center gap-1 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            <input
              type="checkbox"
              className="flex-shrink-0"
              checked={form.hasAttachment}
              onChange={(e) => handleChange("hasAttachment", e.target.checked)}
            />
            <span className="min-w-0 flex-1 truncate" style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>첨부물 있음</span>
          </label>
        </div>

        <textarea
          className="w-full border rounded px-2 py-1.5 text-xs min-w-0" style={{ fontSize: '0.75rem', paddingLeft: '0.5rem', paddingRight: '0.5rem', paddingTop: '0.375rem', paddingBottom: '0.375rem', width: '100%', maxWidth: '100%', boxSizing: 'border-box', minHeight: '4rem' }}
          placeholder="결과 내용 또는 코멘트를 입력하세요"
          value={form.comment}
          onChange={(e) => handleChange("comment", e.target.value)}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
          <div className="flex flex-col gap-2 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            <label className="text-xs font-medium" style={{ fontSize: '0.75rem' }}>작성자</label>
            <input
              className="w-full border rounded px-2 py-1.5 text-xs min-w-0" style={{ fontSize: '0.75rem', paddingLeft: '0.5rem', paddingRight: '0.5rem', paddingTop: '0.375rem', paddingBottom: '0.375rem', width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
              value={form.writer}
              onChange={(e) => handleChange("writer", e.target.value)}
              placeholder="이름"
            />
          </div>
          <div className="flex flex-col gap-2 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            <label className="text-xs font-medium" style={{ fontSize: '0.75rem' }}>승인자</label>
            <input
              className="w-full border rounded px-2 py-1.5 text-xs min-w-0" style={{ fontSize: '0.75rem', paddingLeft: '0.5rem', paddingRight: '0.5rem', paddingTop: '0.375rem', paddingBottom: '0.375rem', width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
              value={form.approver}
              onChange={(e) => handleChange("approver", e.target.value)}
              placeholder="이름"
            />
          </div>
        </div>

        <div className="flex justify-end min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
          <button
            type="button"
            onClick={handleSubmit}
            className="btn-save text-xs px-2.5 py-1.5" style={{ fontSize: '0.75rem', paddingLeft: '0.625rem', paddingRight: '0.625rem', paddingTop: '0.375rem', paddingBottom: '0.375rem' }}
          >
            회신 등록
          </button>
        </div>
      </div>
    </section>
  );
}
